'use client'

import { TagThumbnail } from '@/components/ui/tag-thumbnail'
import { useX2CoolCashProducts } from '@/hooks/react-query/products/use-collection-products'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { stringToSlug } from '@/lib/utils'
import { ETags } from '@/types/product'
import { Star } from 'lucide-react'
import Image from 'next/image'
import { useMemo } from 'react'
import { useAmazonProductCardContext } from './context/amazon-product-card-context'

const tagBackground = {
  [ETags.PREORDER]: 'bg-neutral-900',
  [ETags.CLEANDYE]: 'bg-neutral-900',
  [ETags.LIMITED_QUANTITY]: 'bg-neutral-900',
  [ETags.SALE]: 'bg-secondary',
  [ETags.BAN_CHAY]: 'bg-neutral-900',
  [ETags.NEW]: 'bg-primary-500',
  [ETags.BESTSELLER]: 'bg-neutral-900',
  [ETags.LIMITED]: 'bg-neutral-900',
  [ETags.PREMIUM]: 'bg-neutral-900',
  [ETags.DANG_MUA]: 'bg-neutral-900',
}

export const AmazonProductItemHeader = () => {
  const { product } = useAmazonProductCardContext()
  const { data: x2CoolCashProducts } = useX2CoolCashProducts()

  const isX2CoolCash = useMemo(() => {
    if (!x2CoolCashProducts) return false

    const idSet = new Set(x2CoolCashProducts.product_ids)
    const collectionSet = new Set(x2CoolCashProducts.collection_list)

    return (
      idSet.has(product.id) ||
      product.collections?.some((c) => collectionSet.has(c))
    )
  }, [x2CoolCashProducts, product])

  const isFriday = false

  const isShowX2CoolCashTags = isX2CoolCash || isFriday

  const productTags = Array.isArray(product.tags)
    ? product.tags
    : Object.keys(product.tags || {})

  const ratingValue = product.review?.ratingValue

  if (productTags.length === 0 && !isShowX2CoolCashTags && !ratingValue) {
    return null
  }

  return (
    <div className='absolute left-3 right-3 top-3 flex items-start justify-between'>
      {/* Left: Rating */}
      <div>
        {ratingValue && ratingValue > 0 ? (
          <div className='flex items-center gap-0.5'>
            <span className='text-sm font-medium text-neutral-900'>
              {ratingValue}
            </span>
            <Star size={12} className='fill-black text-black' />
          </div>
        ) : null}
      </div>

      {/* Right: Tags */}
      <div className='flex flex-col items-end gap-1 md:gap-2'>
        {productTags.map((tag) =>
          tag === 'Good Price' ? (
            <Image
              key={tag}
              src={ImageHelper.getImageUrlCdn(
                '/image/July2025/mceclip6_30.png'
              )}
              alt='Good Price'
              width={49}
              height={26}
              className='h-auto w-1/5 md:w-1/6 2xl:w-[12%]'
              unoptimized
            />
          ) : (
            <TagThumbnail
              key={tag}
              title={tag}
              variant='amazon'
              size='small'
              className={
                tagBackground[stringToSlug(tag) as keyof typeof tagBackground]
              }
            />
          )
        )}
        {isShowX2CoolCashTags && (
          <Image
            src={ImageHelper.getImageUrlCdn(
              '/image/November2024/mceclip0_82.png'
            )}
            alt='X2 CoolCash'
            width={24}
            height={24}
            className='h-auto w-1/5 md:w-1/6 2xl:w-[12%]'
            unoptimized
          />
        )}
      </div>
    </div>
  )
}
